"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));
/** A group of single-topic panels that summarize information */


var CardGroup = function CardGroup(props) {
  var htmlId = props.htmlId,
      className = props.className,
      seamless = props.seamless,
      children = props.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: htmlId,
    className: (0, _classnames["default"])(["card__card-group-wrapper", className, seamless && "card__card-group-seamless"])
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "card__card-group"
  }, children));
};

var _default = CardGroup;
exports["default"] = _default;